import { render, staticRenderFns } from "./templateSettings.vue?vue&type=template&id=dee45580&scoped=true&"
import script from "./templateSettings.vue?vue&type=script&lang=js&"
export * from "./templateSettings.vue?vue&type=script&lang=js&"
import style0 from "./templateSettings.vue?vue&type=style&index=0&id=dee45580&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dee45580",
  null
  
)

export default component.exports